"use strict";var u=Object.defineProperty;var h=Object.getOwnPropertyDescriptor;var i=(n,a,e,s)=>{for(var t=s>1?void 0:s?h(a,e):a,l=n.length-1,c;l>=0;l--)(c=n[l])&&(t=(s?c(a,e,t):c(t))||t);return s&&t&&u(a,e,t),t};import{baseStyles as p,CiscoUElement as v,html as r,nothing as d}from"@cisco-u/base";import{property as o,queryAssignedElements as m}from"@cisco-u/base/src/decorators.js";import"@cisco-u/logo/cu-logo.js";import"@cisco-u/icons/icons/cu-icon-menu.js";import"@cisco-u/icons/icons/cu-icon-close-x.js";import"@cisco-u/icons/icons/cu-icon-search.js";import"@cisco-u/icons/icons/cu-icon-cart-thick.js";import"@cisco-u/button/cu-button.js";import"@cisco-u/text-select-field/cu-text-select-field.js";import{menuIcon as b}from"./assets/menu-icon.js";import f from"./top-header.css.js";export class TopHeader extends v{constructor(){super(...arguments);this.dark=!1;this.open=!1;this.admin=!1;this.searchopen=!1;this.header=!0;this.sticky=!1;this.unrestricted=!1;this._throttledMenuOpen=this._throttle(this._setMenuOpen.bind(this),50)}static get styles(){return[p,f]}updated(e){e.has("open")&&this._setMenuOpen()}connectedCallback(){super.connectedCallback(),window.addEventListener("resize",this._throttledMenuOpen)}disconnectedCallback(){super.disconnectedCallback(),document.body.style.overflow="auto",window.removeEventListener("resize",this._throttledMenuOpen)}render(){return this.header?r`<header>${this._returnHeaderBody()}</header>`:r`<div>${this._returnHeaderBody()}</div>`}_returnHeaderBody(){return r`<div class="head-inner">
        <div class="nav-wrap">
          <div class="nav-bar">
            <div class="menu-button">
              <button
                class="btn-reset"
                @click=${this._openMenu}
                title=${this.open?"Close Menu":"Open Menu"}
              >
                ${b()}
              </button>
            </div>
            <div class="logo">
              <a
                href=${this.logoLink||"#"}
                title=${this.admin?"Cisco Admin Portal":"Cisco U. Home"}
                @click=${this._dispatchLogo}
                >${this._returnLogo()}</a
              >
            </div>
            <div class="nav-items">
              <slot name="nav-item"></slot>
            </div>
            ${this._returnActions()}
          </div>
          <div class="mobile-search-wrap">
            <div class="mobile-search">
              <cu-text-select-field
                @receiveValue=${this._handleSearch}
                id="header-search-2"
                submittype="search"
                value=${this.searchtext||d}
                noManualErase
                placeholder="What would you like to learn?"
                thin
                grey
              ></cu-text-select-field>
            </div>
          </div>
        </div>
      </div>
      ${this._returnOffcanvas()}
      <div class="backdrop" @click=${this._openMenu}></div>`}_handleSearch(e){e.detail.type!=="blur"&&this._dispatchSearch(e)}_returnLogo(){return this.admin?r`<cu-logo type="admin-portal"></cu-logo>`:this.dark?r`<cu-logo type="cisco-u"></cu-logo>`:r`<cu-logo type="black-cisco-u"></cu-logo>`}_returnActions(){return r`<div class="actions">
      <div class="search-wrap">
        <cu-text-select-field
          @receiveValue=${this._handleSearch}
          id="header-search"
          submittype="search"
          value=${this.searchtext||d}
          noManualErase
          placeholder="What would you like to learn?"
          thin
          grey
        ></cu-text-select-field>
      </div>
      <div class="search-action">
        <button class="btn-reset search-btn" @click=${this._openSearch}>
          <cu-icon-search size="l"></cu-icon-search>
        </button>
      </div>
      <slot name="action-item"></slot>
    </div>`}_returnOffcanvas(){return r`<div class="offcanvas">
      <slot
        name="mobile-nav-item"
        @slotchange=${this._slotChangeHandler}
      ></slot>
      <div class="mobile-footer">
        <slot name="mobile-footer-item"></slot>
      </div>
    </div>`}_slotChangeHandler(){this.mobileItems.forEach(e=>{e instanceof HTMLElement&&e.classList.remove("first","last")}),this.mobileItems[0].classList.add("first"),this.mobileItems[this.mobileItems.length-1].classList.add("last")}_dispatchSearch(e){const s={detail:{search:e.detail.textValue},bubbles:!0,composed:!0};this.dispatchEvent(new CustomEvent("cu-header-search",s))}_dispatchLogo(e){const s={detail:{event:e},bubbles:!0,composed:!0,cancelable:!0};this.dispatchEvent(new CustomEvent("cu-header-logo",s))}_openMenu(){this.open=!this.open}_openSearch(){this.searchopen=!this.searchopen}_setMenuOpen(){this.open&&window.innerWidth<1024?document.body.style.overflow="hidden":document.body.style.overflow="auto"}_throttle(e,s){let t=null;return()=>{t||(e(),t=setTimeout(()=>{t=null},s))}}}i([o({type:Boolean,reflect:!0})],TopHeader.prototype,"dark",2),i([o({type:Boolean,reflect:!0})],TopHeader.prototype,"open",2),i([o({type:Boolean,reflect:!0})],TopHeader.prototype,"admin",2),i([o({type:Boolean,reflect:!0})],TopHeader.prototype,"searchopen",2),i([o({type:Boolean,reflect:!0})],TopHeader.prototype,"header",2),i([o({type:Boolean,reflect:!0})],TopHeader.prototype,"sticky",2),i([o({type:String,reflect:!0})],TopHeader.prototype,"logoLink",2),i([o({type:String,reflect:!0})],TopHeader.prototype,"searchtext",2),i([o({type:Boolean,reflect:!0})],TopHeader.prototype,"unrestricted",2),i([m({slot:"mobile-nav-item"})],TopHeader.prototype,"mobileItems",2);
//# sourceMappingURL=TopHeader.js.map
